import Vue from "vue";
import VueRouter from "vue-router";
import defaultLayout from "@/layouts/default.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: defaultLayout,
    children: [
      {
        path: "/courses",
        name: "courses",
        component: () => import("@/views/courses/courseIndex.vue"),
      },
      {
        path: "/viewCourse/:id",
        name: "show",
        component: () => import("@/views/courses/viewCourse.vue"),
      },
      {
        path: "/students",
        name: "students",
        component: () => import("@/views/students/studentsIndex.vue"),
      },
      {
        path: "/students/:id",
        name: "show",
        component: () => import("@/views/students/show.vue"),
      },
      {
        path: "/TypeOfNotes",
        name: "TypeOfNotes",
        component: () => import("@/views/TypeOfNotes/index.vue"),
      },
      {
        path: "/multiNotes",
        name: "multiNotes",
        component: () => import("@/views/notes/multiNotes.vue"),
      },
      {
        path: "/singleNotes",
        name: "singleNotes",
        component: () => import("@/views/notes/singleNotes.vue"),
      },
      {
        path: "/branches",
        name: "branches",
        component: () => import("@/views/branches/index.vue"),
      },
      {
        path: "/admins",
        name: "admins",
        component: () => import("@/views/admins/index.vue"),
      },
    ],
  },

  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
